import React, { useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SearchBar from './SearchBar';

const navLinks = [
  { to: '/', label: 'Inicio', mobileOnly: true },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

const Header = () => {
  const menuRef = useRef();
  const inputRef = useRef();
  const location = useLocation();

  React.useEffect(() => {
    if (inputRef.current) inputRef.current.checked = false;
  }, [location]);

  React.useEffect(() => {
    function handleClick(e) {
      if (
        inputRef.current &&
        inputRef.current.checked &&
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        e.target.id !== 'menu-toggle' &&
        e.target.htmlFor !== 'menu-toggle'
      ) {
        inputRef.current.checked = false;
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <header className="border-b border-gray-200">
      <nav className="container mx-auto flex items-center justify-between py-4 px-4 md:px-0">
        <Link to="/" className="flex flex-col items-start group">
          <img src="/logo-header.avif" alt="Logo" className="h-20" />
        </Link>
        <input id="menu-toggle" type="checkbox" className="hidden peer" ref={inputRef} />
        <label htmlFor="menu-toggle" className="md:hidden cursor-pointer">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
        </label>
        <ul
          ref={menuRef}
          className="flex-col md:flex-row md:flex gap-6 md:gap-8 font-medium hidden md:flex peer-checked:flex absolute md:static top-16 left-1/2 md:left-0 -translate-x-1/2 md:translate-x-0 w-11/12 md:w-auto bg-white md:bg-transparent shadow md:shadow-none z-10 md:z-auto rounded-xl md:rounded-none py-6 md:py-0 items-center justify-center text-center"
        >
          {navLinks.map(link => {
            const isActive = location.pathname === link.to;
            return (
              <li key={link.to} className={link.mobileOnly ? 'block md:hidden' : ''}>
                <Link
                  to={link.to}
                  className={`transition-all duration-200 ease-in-out hover:text-indigo-600 focus:text-indigo-600 hover:scale-105 focus:scale-105 inline-block px-2 py-1 rounded-md flex items-center gap-1`}
                  tabIndex={0}
                >
                  {isActive && (
                    <span className="text-indigo-500 text-lg -ml-1">•</span>
                  )}
                  {link.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
      <div className="w-full bg-white border-b border-gray-100">
        <div className="container mx-auto px-4 md:px-0 py-3 flex justify-center">
          <SearchBar />
        </div>
      </div>
    </header>
  );
};

export default Header;
